module.exports = __webpack_public_path__ + "84714bcc56289d5e91c9e14afadebed4.MP3";